<!--
 * @LastEditors: chuhongguang
 * @desc: 二维散点图
 * @场景: 重构公式 抽屉 - 最近记录 - 点击对比（2-3个不同的名称）
-->
<template>
  <div style="text-align: left;">
    <div :id="this.id" :style="{height: '300px', width: '100%'}"></div>
  </div>
</template>
<script>
export default {
  props: ['id', 'serieData', 'serieName', 'serie3Data'],
  data () {
    return {
      myChart: null,
      option: {}
    }
  },
  mounted () {
    this.drawLine()
    if (this.serieName.length > 2) {
      this.option['series'][0].data = this.serie3Data[0]
      this.option['series'].push({
        symbolSize: 5,
        name: this.serieName[2],
        data: this.serie3Data[1],
        type: 'scatter'
      })
      this.myChart.setOption(this.option)
    } else {
      this.option['series'][0].data = this.serieData
      this.myChart.setOption(this.option)
    }
  },
  methods: {
    unique (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart === null) {
        this.myChart = this.$echarts.init(document.getElementById(this.id))
      }
      this.option = {
        tooltip: {
          trigger: 'axis',
          triggerOn: 'click',
          enterable: true,
          formatter: (param) => {
            let data = param[0]
            let text = data.axisValue
            let valueItem = []
            for (let i = 0; i < param.length; i++) {
              if (param[i].value) {
                valueItem.push(param[i].value[1])
              }
            }
            valueItem = this.unique(valueItem)
            for (let j = 0; j < valueItem.length; j++) {
              text = text + '<br/>' + '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:' + data.color + '"></span>' + valueItem[j]
            }
            return text
          },
          extraCssText: 'max-width: 300px;white-space: normal; word-break: break-all;'
        },
        toolbox: {
          show: true
        },
        legend: {
          show: true,
          data: [this.serieName[1], this.serieName[2]]
          // type: 'scroll',
          // formatter: function (name) {
          //   return name.length > 20 ? name.substr(0, 20) + '...' : name
          // }
        },
        grid: {
          // show: true,
          z: 0,
          top: 50,
          left: 115
        },
        xAxis: {
          name: this.serieName[0],
          min: 'dataMin',
          max: 'dataMax',
          nameGap: 25, // x轴name与横坐标轴线的间距
          nameLocation: 'middle',
          axisLine: {
            onZero: false // -----------重点
          }
        },
        yAxis: {
          name: this.serieName[1],
          min: 'dataMin',
          max: 'dataMax',
          nameTextStyle: {
            align: 'left',
            padding: [0, 0, 0, -60]
          },
          axisLine: {
            onZero: false // -----------重点
          }
        },
        series: [{
          symbolSize: 5,
          name: this.serieName[1],
          color: '#c64743',
          data: [],
          type: 'scatter'
        }],
        dataZoom: [
          {
            type: 'inside',
            min: 'dataMin',
            max: 'dataMax'
          },
          {
            show: true,
            type: 'slider',
            fillerColor: 'rgba(167, 183, 204, 0.4)',
            // handleStyle: {
            //   color: '#a7b7cc',
            //   borderColor: '#000'
            // },
            top: '90%'
          }
        ]
      }
      var _this = this
      this.myChart.setOption(this.option)
      window.addEventListener('resize', function () {
        _this.myChart.resize()
        if (_this.myChart) {
          _this.myChart.resize()
        }
      })
    },
    clearData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.myChart = this.$echarts.init(document.getElementById(this.id))
      this.myChart.clear()
    }
  },
  watch: {
    serieData (newVal, oldVal) {
      this.clearData()
      this.drawLine()
      if (!newVal || newVal.length < 1) {
        return
      }
      this.serieData = newVal
    },
    serie3Data (newVal, oldVal) {
      this.clearData()
      this.drawLine()
      if (!newVal || newVal.length < 1) {
        return
      }
      this.serie3Data = newVal
    },
    id (newVal, oldVal) {
      this.id = newVal
    },
    serieName (newVal, oldVal) {
      this.serieName = newVal
      if (this.serieName.length > 2) {
        this.option['series'][0].data = this.serie3Data[0]
        this.option['series'].push({
          symbolSize: 5,
          name: this.serieName[2],
          data: this.serie3Data[1],
          type: 'scatter'
        })
        this.myChart.setOption(this.option)
      } else {
        this.option['series'][0].data = this.serieData
        this.myChart.setOption(this.option)
      }
    }
  },
  activated () {
    this.clearData()
  }
}
</script>
<style scoped>
  .el-collapse-item {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__header {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__wrap {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  h4 {
    margin-bottom:0px;
  }
  .bannerTextRed{
    padding: 0 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 4px;
    font-weight: 400;
    background-color:indianred;
    color:white;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dailyBack/reconstrucScatter.vue